import z from "zod";

export const articleGroupFormSchema = z.object({
	id: z.string().nullish(),
	name: z.string(),
	number: z.coerce.number().min(0).max(999),
	autoGenerateNumber: z.preprocess((val) => {
		if (!val) return false;
		return true;
	}, z.boolean()),
	description: z.string().nullish(),
});

export type ArticleGroupFormSchema = z.infer<typeof articleGroupFormSchema>;
